<div class="card text-left">
  <div class="card-body" style="background-color: #e4ecf2;">
    <h4 class="card-title" style="text-align: center;">Skills Training Provider (STP) Registration </h4>
    <h5 class="text-danger text-center" *ngIf="stpMainInfo?.isTempRejected">
        <b>***Your application needs correction.</b>
        <span *ngIf="stpMainInfo?.tempRejectReason">
          Reason: {{stpMainInfo?.tempRejectReason}}
        </span>
      </h5>
  </div>
</div>
<!-- Rollback History is for NSDA users only: the STP sees just the correction reason above -->
<div *ngIf="!isStpUser && stpRollbackHistory.length > 0">
  <div class="ng-Header col-xs-12">
    <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Rollback History
  </div>

  <nz-table
    #historyTable
    [nzData]="stpRollbackHistory || []"
    [nzBordered]="true"
    nzSize="small"
    [nzPageSize]="5"
    [nzFrontPagination]="true"
    [nzShowPagination]="true"
    [nzShowTotal]="totalRowRangeTemplate"
    [nzNoResult]="noRollbackHistoryTpl"
  >
    <ng-template #totalRowRangeTemplate let-range="range" let-total>
      <div class="table-total-text">
        Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
      </div>
    </ng-template>

    <thead>
      <tr>
        <th nzWidth="60px" nzAlign="center">#</th>
        <th nzWidth="140px">Type</th>
        <th>Remarks</th>
        <th nzWidth="180px">Date</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let item of historyTable.data; let i = index" [class.rollback-history-first-row]="i === 0">
        <td nzAlign="center">
          {{ (historyTable.nzPageIndex - 1) * historyTable.nzPageSize + i + 1 }}
        </td>

        <td>
          <nz-tag
            [nzColor]="
              item.rollbackApplicationTypeName === 'Renew' ? 'blue' : 'orange'
            "
          >
            {{ item.rollbackApplicationTypeName || "N/A" }}
          </nz-tag>
        </td>

        <td class="remarks-cell">
          {{ item.remarks || "N/A" }}
        </td>

        <td>
          {{
            item.createdAt
              ? (item.createdAt | date: "dd-MM-yyyy hh:mm a")
              : "N/A"
          }}
        </td>
      </tr>
    </tbody>
  </nz-table>

  <ng-template #noRollbackHistoryTpl>
    <nz-empty nzNotFoundContent="No rollback history found"></nz-empty>
  </ng-template>
</div>
<nz-tabset nzType="card" nzCentered [(nzSelectedIndex)]="selectedIndex">
  <nz-tab nzTitle="Basic Profile">
    <app-basic-profile-renew-reapply [stpMainId]="this.stpMainId" (stpMainDumpId)="getStpMainDumpId($event)"></app-basic-profile-renew-reapply>
  </nz-tab>
  <nz-tab nzTitle="Physical Infrastructure">
    <app-physical-infrastructure-renew-reapply [stpMainId]="this.stpMainId" [stpMainDumpId]="this.stpMainDumpId"></app-physical-infrastructure-renew-reapply>
  </nz-tab>
  <nz-tab nzTitle="Trainer">
    <app-occupation-specific-trainer-renew-reapply [stpMainId]="this.stpMainId" [stpMainDumpId]="this.stpMainDumpId"></app-occupation-specific-trainer-renew-reapply>
  </nz-tab>
  <nz-tab nzTitle="Management & Staff">
    <app-management-and-staffs-renew-reapply [stpMainId]="this.stpMainId" [stpMainDumpId]="this.stpMainDumpId"></app-management-and-staffs-renew-reapply>
  </nz-tab>
  <nz-tab nzTitle="Financial Details">
    <app-financial-details-renew-reapply [stpMainId]="this.stpMainId" [stpMainDumpId]="this.stpMainDumpId"></app-financial-details-renew-reapply>
  </nz-tab>
  <nz-tab nzTitle="Occupation Specific Tools">
    <app-occupation-specific-tools-renew-reapply [stpMainId]="this.stpMainId" [stpMainDumpId]="this.stpMainDumpId"></app-occupation-specific-tools-renew-reapply>
  </nz-tab>
  <nz-tab nzTitle="Furniture">
    <app-furniture-list-renew-reapply [stpMainId]="this.stpMainId" [stpMainDumpId]="this.stpMainDumpId"></app-furniture-list-renew-reapply>
  </nz-tab>
  <!-- <nz-tab nzTitle="Payment">
    <app-stp-payment-renew-reapply [stpMainId]="this.stpMainId" [stpMainDumpId]="this.stpMainDumpId"></app-stp-payment-renew-reapply>
  </nz-tab> -->
</nz-tabset>
